import { render, staticRenderFns } from "./vipMask.vue?vue&type=template&id=697ad204&scoped=true&"
import script from "./vipMask.vue?vue&type=script&lang=ts&"
export * from "./vipMask.vue?vue&type=script&lang=ts&"
import style0 from "./vipMask.vue?vue&type=style&index=0&id=697ad204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697ad204",
  null
  
)

export default component.exports